import { objectsRHandler } from '@/utils/objectsRHandler';

import EventDocument from '../list/event-document';

const API_PATH = 'admin/event-directory-document-options';

export const AdminEventDirectoryDocumentOptionsManager = {
  objects: objectsRHandler(API_PATH, EventDocument),
};
